exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lbaPolicyCodeSelect_list{margin:1rem 0}.lbaPolicyCodeSelect_uiSelect{display:inline-block;width:30rem;margin:0 1rem 0 0}.lbaPolicyCodeSelect_uiSelect .form-control{width:100%}", "", {"version":3,"sources":["/../../../../../sassjs-loader/index.js!/home/vsts/work/1/s/src/components/lbaPolicyCodeSelect/lbaPolicyCodeSelect.scss"],"names":[],"mappings":"AAAA,0BACE,aAAe,CAAE,AAEnB,8BACE,qBAAsB,AACtB,YAAa,AACb,iBAAmB,CAAE,AACrB,4CACE,UAAY,CAAE","file":"lbaPolicyCodeSelect.scss","sourcesContent":[".lbaPolicyCodeSelect_list {\n  margin: 1rem 0; }\n\n.lbaPolicyCodeSelect_uiSelect {\n  display: inline-block;\n  width: 30rem;\n  margin: 0 1rem 0 0; }\n  .lbaPolicyCodeSelect_uiSelect .form-control {\n    width: 100%; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sassjs-loader!./src/components/lbaPolicyCodeSelect/lbaPolicyCodeSelect.scss
// module id = 401
// module chunks = 0